export default __webpack_public_path__ + "static/media/cloud-2.7a6c4b4b.webp";